module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-lookup-outer"
  }, [_c('div', {
    ref: "lookup",
    staticClass: "rt-lookup",
    class: [
      _vm.multiple ? 'is-multiple' : 'is-single',
      _vm.multiple && _vm.max && _vm.tagInputFocus ? 'rt-lookup-input-focus' : '',
      _vm.max ? '' : 'rt-lookup-no-height'
    ],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.rtLookupShowHandler.apply(null, arguments)
      }
    }
  }, [(_vm.$slots.prefix) ? _c('div', {
    ref: "prefix",
    staticClass: "rt-lookup-prefix"
  }, [_vm._t("prefix")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    class: [
      'lookup-wrap',
      _vm.isLink ? 'is-link' : '',
      _vm.tagInputFocus ? 'input-focus' : ''
    ],
    on: {
      "mouseenter": function($event) {
        _vm.inputHovering = true
      },
      "mouseleave": function($event) {
        _vm.inputHovering = false
      }
    }
  }, [(_vm.list && _vm.list.length > 0) ? _c('div', {
    staticClass: "lookup-main",
    on: {
      "click": _vm.focusTagInput
    }
  }, [_c('span', {
    ref: "tag",
    style: ({
      position: 'absolute',
      opacity: 0,
      'pointer-events': 'none'
    })
  }, _vm._l((_vm.list), function(item, index) {
    return _c('rt-tag', {
      key: index,
      staticClass: "rt-tag-box",
      attrs: {
        "size": "medium",
        "disabled": _vm.computedDisabled,
        "closable": !_vm.computedDisabled,
        "type": "outline",
        "text-type": _vm.isLink ? 'primary' : ''
      },
      on: {
        "close": function () {}
      }
    }, [_vm._v(_vm._s(item[_vm.alias.name]))])
  }), 1), _vm._v(" "), (!!_vm.$scopedSlots.popover) ? [(_vm.max && _vm.list.length > _vm.maxIndex && !_vm.tagInputFocus) ? [_c('div', {
    staticClass: "tag"
  }, [_vm._l((_vm.list.slice(0, _vm.maxIndex)), function(item, index) {
    return _c('rt-popover', _vm._b({
      key: index
    }, 'rt-popover', _vm.computedPopoverOptions, false), [_c('rt-tag', {
      attrs: {
        "slot": "reference",
        "disabled": _vm.computedDisabled,
        "closable": !_vm.computedDisabled,
        "type": "outline",
        "size": "medium",
        "text-type": _vm.isLink ? 'primary' : ''
      },
      on: {
        "close": function($event) {
          return _vm.del(index)
        }
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.onTagClick(item, item[_vm.alias.name])
        }
      },
      slot: "reference"
    }, [_vm._v("\n                  " + _vm._s(item[_vm.alias.name]) + "\n                ")]), _vm._v(" "), _vm._t("popover", null, {
      "item": item
    })], 2)
  }), _vm._v(" "), _c('rt-tooltip', {
    attrs: {
      "content": _vm.contentPopover,
      "placement": "bottom"
    }
  }, [_c('rt-tag', {
    attrs: {
      "disabled": _vm.computedDisabled,
      "closable": !_vm.computedDisabled,
      "type": "outline",
      "size": "medium",
      "text-type": _vm.isLink ? 'primary' : ''
    },
    on: {
      "close": function($event) {
        return _vm.del(_vm.list.length - 1)
      }
    }
  }, [_vm._v("\n                  +" + _vm._s(_vm.list.length - _vm.maxIndex) + "\n                ")])], 1)], 2)] : _vm._l((_vm.list), function(item, index) {
    return _c('rt-popover', _vm._b({
      key: index
    }, 'rt-popover', _vm.computedPopoverOptions, false), [_c('rt-tag', {
      attrs: {
        "slot": "reference",
        "disabled": _vm.computedDisabled,
        "closable": _vm.multiple ? !_vm.computedDisabled : false,
        "type": "outline",
        "size": "medium",
        "text-type": _vm.isLink ? 'primary' : '',
        "max-width": _vm.computedDisabled && _vm.list.length === 1 ? '100%' : '200px'
      },
      on: {
        "close": function($event) {
          return _vm.del(index)
        }
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.onTagClick(item, item[_vm.alias.name])
        }
      },
      slot: "reference"
    }, [_vm._v("\n                " + _vm._s(item[_vm.alias.name]) + "\n              ")]), _vm._v(" "), _vm._t("popover", null, {
      "item": item
    })], 2)
  })] : [(_vm.max && _vm.list.length > _vm.maxIndex && !_vm.tagInputFocus) ? [_c('div', {
    staticClass: "tag"
  }, [_vm._l((_vm.list.slice(0, _vm.maxIndex)), function(item, index) {
    return _c('rt-tag', {
      key: index,
      attrs: {
        "disabled": _vm.computedDisabled,
        "closable": !_vm.computedDisabled,
        "type": "outline",
        "size": "medium",
        "text-type": _vm.isLink ? 'primary' : ''
      },
      on: {
        "close": function($event) {
          return _vm.del(index)
        }
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.onTagClick(item, item[_vm.alias.name])
        }
      }
    }, [_vm._v("\n                " + _vm._s(item[_vm.alias.name]) + "\n              ")])
  }), _vm._v(" "), _c('rt-tooltip', {
    attrs: {
      "content": _vm.contentPopover,
      "placement": "bottom"
    }
  }, [_c('rt-tag', {
    attrs: {
      "disabled": _vm.computedDisabled,
      "closable": !_vm.computedDisabled,
      "type": "outline",
      "size": "medium",
      "text-type": _vm.isLink ? 'primary' : ''
    },
    on: {
      "close": function($event) {
        return _vm.del(_vm.list.length - 1)
      }
    }
  }, [_vm._v("\n                  +" + _vm._s(_vm.list.length - _vm.maxIndex) + "\n                ")])], 1)], 2)] : _vm._l((_vm.list), function(item, index) {
    return _c('rt-tag', {
      key: index,
      attrs: {
        "disabled": _vm.computedDisabled,
        "closable": _vm.multiple ? !_vm.computedDisabled : false,
        "type": "outline",
        "size": "medium",
        "max-width": _vm.computedDisabled && _vm.list.length === 1 ? '100%' : '200px',
        "text-type": _vm.isLink ? 'primary' : ''
      },
      on: {
        "close": function($event) {
          return _vm.del(index)
        }
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.onTagClick(item, item[_vm.alias.name])
        }
      }
    }, [_vm._v("\n              " + _vm._s(item[_vm.alias.name]) + "\n            ")])
  })], _vm._v(" "), (_vm.tagInputFocus && _vm.multiple && _vm.lookupHeight > 35) ? _c('rt-input', {
    ref: "tagInput",
    staticClass: "rt-lookup-tag-input",
    class: {
      'rt-lookup-allow-input': _vm.allowInput
    },
    attrs: {
      "type": "autocomplete",
      "fetch-suggestions": _vm.fetchSuggestions,
      "trigger-on-focus": _vm.triggerOnFocus,
      "show-suffix-icon": false,
      "clearable": false,
      "highlight-first-item": _vm.computedHighlightFirstItem,
      "readonly": !_vm.allowInput,
      "disabled": _vm.computedDisabled,
      "hide-option-desc": _vm.hideOptionDesc
    },
    on: {
      "select": _vm.addValue,
      "input": _vm.inputHandler,
      "blur": _vm.blurHandler
    },
    nativeOn: {
      "keydown": function($event) {
        return _vm.keydownHandler.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.tagInputText),
      callback: function($$v) {
        _vm.tagInputText = $$v
      },
      expression: "tagInputText"
    }
  }) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('rt-input', {
    ref: "input",
    class: {
      'rt-lookup-allow-input': _vm.allowInput
    },
    attrs: {
      "type": "autocomplete",
      "fetch-suggestions": _vm.fetchSuggestions,
      "trigger-on-focus": _vm.triggerOnFocus,
      "show-suffix-icon": false,
      "clearable": false,
      "highlight-first-item": _vm.computedHighlightFirstItem,
      "readonly": !_vm.allowInput,
      "placeholder": _vm.computedPlaceholder,
      "disabled": _vm.computedDisabled,
      "hide-option-desc": _vm.hideOptionDesc
    },
    on: {
      "select": _vm.addValue,
      "input": _vm.inputHandler,
      "change": _vm.changeHandler,
      "focus": _vm.focusHandler,
      "blur": _vm.blurHandler
    },
    nativeOn: {
      "mouseenter": function($event) {
        _vm.inputHovering = true
      },
      "mouseleave": function($event) {
        _vm.inputHovering = false
      },
      "keydown": function($event) {
        return _vm.keydownHandler.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.inputText),
      callback: function($$v) {
        _vm.inputText = $$v
      },
      expression: "inputText"
    }
  })], 1), _vm._v(" "), (_vm.showClose) ? _c('rt-icon', {
    staticClass: "rt-lookup-suffix rt-lookup-suffix_close rt-lookup-clearicon-position",
    class: {
      'rt-lookup-clearicon-position': _vm.allowInput
    },
    staticStyle: {
      "margin-right": "30px",
      "width": "24px",
      "height": "24px"
    },
    attrs: {
      "name": _vm.computedIconName
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.clear.apply(null, arguments)
      }
    },
    nativeOn: {
      "mouseenter": function($event) {
        _vm.inputHovering = true
      },
      "mouseleave": function($event) {
        _vm.inputHovering = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('rt-tooltip', {
    attrs: {
      "disabled": !_vm.iconContent,
      "content": _vm.iconContent,
      "placement": "right"
    }
  }, [_c('rt-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.computedDisabled),
      expression: "!computedDisabled"
    }],
    staticClass: "rt-lookup-suffix rt-lookup-suffix_lookup lookup-icon",
    attrs: {
      "name": _vm.suffixIconName
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.show.apply(null, arguments)
      }
    },
    nativeOn: {
      "mouseenter": function($event) {
        _vm.inputHovering = false
      },
      "mouseleave": function($event) {
        _vm.inputHovering = false
      }
    }
  })], 1), _vm._v(" "), _c('rt-lookup-view', _vm._b({
    ref: "lookupView",
    attrs: {
      "fetch": _vm.fetchRecord,
      "display-fields": _vm.displayFields,
      "list": _vm.list,
      "multiple": _vm.multiple,
      "title": _vm.title,
      "size": _vm.size,
      "total": _vm.total,
      "alias": _vm.alias,
      "request-alias": _vm.requestAlias,
      "keep-selected": _vm.keepSelected,
      "page-fields": _vm.innerPageFields
    },
    on: {
      "confirm": _vm.confirm,
      "change": _vm.change
    }
  }, 'rt-lookup-view', _vm.$attrs, false), [_vm._t("footer-left", null, {
    "slot": "footer-left"
  })], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-292ae8d3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/lookup/rtLookup.vue
// module id = 2096
// module chunks = 137